import React from "react";
import { NavLink } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import logo from '../images/logo.png';
import UserServices from "../services/UserServices";

const Navbar = () => {
    const navigate = useNavigate();
    let droit = false;
    let role = 'user';


    let loggedIn = false;
    const token = localStorage.getItem('token');
    if (token) {
        loggedIn = true;
        role = localStorage.getItem('role');
        if (role === 'admin') {
            droit = true;
        }
    }
    function handleLogout(event) {
        let id = parseInt(localStorage.getItem('token'));
        UserServices.Logout(id);
        localStorage.removeItem('token');
        loggedIn = false;
        navigate('/login');
        return;
    }

    return (

        <nav className="navbar navbar-expand-lg navbar-light bg-light mb-5">
            <div className="container-fluid">
                <NavLink className="navbar-brand" to="/consommation">
                    <img src={logo} alt="Logo d'Afribone" />
                </NavLink>

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <NavLink className="nav-link"  exact="true" to="/consommation" activeclassname="active">
                                Consommations
                            </NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink className="nav-link"  exact="true" to="/relais" activeclassname="active">
                                Relais
                            </NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink className="nav-link"  exact="true" to="/role" activeclassname="active">
                                Rôles
                            </NavLink>
                        </li>

                        <li className="nav-item dropdown">
                            <span className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Utilisateurs
                            </span>
                            <ul className="dropdown-menu">
                                <li>
                                    <NavLink className="dropdown-item"  exact="true" to="/profile" activeclassname="active">
                                        Profil
                                    </NavLink>
                                </li>

                                <li><hr className="dropdown-divider" /></li>

                                <li>
                                    <NavLink className="dropdown-item"  exact="true" to="/user" activeclassname="active">
                                        Liste des utilisateurs
                                    </NavLink>
                                </li>

                                <li>
                                    <NavLink className="dropdown-item"  exact="true" to="/user/edit-role" activeclassname="active">
                                        Modifier le rôle
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                        {loggedIn ? (
                            <li className="nav-item d-flex align-items-center">
                                <span className="btn btn-primary btn-sm" onClick={handleLogout}>Se déconnecter</span>
                            </li>
                        ) : (
                            <li className="nav-item d-flex align-items-center">
                                <NavLink className="btn btn-primary btn-sm"  exact="true" to="/login" activeclassname="active">
                                    Se connecter
                                </NavLink>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </nav>

        // <nav className="navbar navbar-expand-lg navbar-light bg-light mb-5">
        //     <div className="container-fluid">
        //         <Link className="navbar-brand" to="/consommation">
        //             <img src={logo} alt="Logo d'Afribone" />
        //         </Link>

        //         <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        //             <span className="navbar-toggler-icon"></span>
        //         </button>
        //         <div className="collapse navbar-collapse" id="navbarSupportedContent">
        //             <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        //                 <li className="nav-item">
        //                     <Link className="nav-link active" to="/consommation">Consommations</Link>
        //                 </li>
        //                 <li className="nav-item">
        //                     <Link className="nav-link" to="/relais">Relais</Link>
        //                 </li>
        //                 <li className="nav-item">
        //                     <Link className="nav-link" to="/role">Rôles</Link>
        //                 </li>
        //                 <li className="nav-item dropdown">
        //                     <span className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
        //                         Utilisateurs
        //                     </span>
        //                     <ul className="dropdown-menu">
        //                         <li><Link className="dropdown-item" to="/profile">Profil</Link></li>
        //                         <li><hr className="dropdown-divider" /></li>
        //                         <li><Link className="dropdown-item" to="/user">Liste des utilisateurs</Link></li>
        //                         <li><Link className="dropdown-item" to="/user/edit-role">Modifier le rôle</Link></li>
        //                     </ul>
        //                 </li>
        //             </ul>
        //             <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        //                 {loggedIn ? (
        //                     <li className="nav-item d-flex align-items-center">
        //                         <span className="btn btn-primary btn-sm" onClick={handleLogout}>Se déconnecter</span>
        //                     </li>
        //                 ) : (
        //                     <li className="nav-item d-flex align-items-center">
        //                         <Link className="btn btn-primary btn-sm" to="/login">Se connecter</Link>
        //                     </li>
        //                 )}
        //             </ul>
        //         </div>
        //     </div>
        // </nav>
    );
}

export default Navbar;